import React from "react";
import { Link } from "gatsby";
import ImageModule from "../../../modules/image_module";
import CTABtnModule from "../../../modules/cta_btn_module";
import { menuLinks } from "../../../common/utils/page_url_utils";
import { AnimationOnScroll } from "react-animation-on-scroll";

const TilesBox = ({item, imagename, strapi_id, processedImages, index, animation_effect, tiles_layout_type, GQLPage, setShowContent, setShow}) => {

    const ImageRenderList = ({item, imagename, strapi_id, processedImages}) => {
        return (
          <ImageModule ImageSrc={item.image} title={item.title} altText={item.title} imagetransforms={processedImages} ggfx_results={GQLPage?.ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={strapi_id} classNames="banner_img" />                           
        )
    }

    var page_link = item?.button_cta?.custom_link ? item.button_cta?.custom_link : item?.button_cta?.menu_item?.slug ? menuLinks(item.button_cta.menu_item) : "";

    var childern = <>
        <div className="tile_img">
            <ImageRenderList item={item} imagename={imagename} processedImages={processedImages} strapi_id={strapi_id}/>
        </div>
        
                    
        <span className="trans_bg"></span>
    
        {item.title || item.content || item.button_cta ? 
            <div className="tiles_content">
                <h3>{item.title} {item.button_cta?.theme === "navigation_arrow" && <i className="icon-caretright-red" />}</h3>
                {item.content && <p>{item.content} </p>}

                {(tiles_layout_type !== "text_under_image") && item.button_cta?.theme !== "navigation_arrow" &&  <CTABtnModule button_cta={item.button_cta}/>
                }
            </div>
            :
            <></>
        }
    </>

    return (
        <React.Fragment>
            {page_link ? 
                <Link to={page_link} className={`tiles_link ${(item?.button_cta?.label || item.button_cta?.theme === "navigation_arrow") ? "" : "no_cta"} ${item.button_cta?.theme === "navigation_arrow" ? "navigate_arw" : ""}`}>
                    {/* <ImageModule ImageSrc={item.image} title={item.title} altText={item.title}  /> */}
                    {childern}
                    {tiles_layout_type === "text_under_image" && item?.button_cta?.label && item.button_cta?.theme !== "navigation_arrow" && 
                        <CTABtnModule button_cta={item.button_cta} />
                    }
                </Link>
            : 
                item?.popup_content ? 
                    <a href="javascript:;" className={`tiles_link ${item?.button_cta?.label ? "" : "no_cta"} ${item.button_cta?.theme === "navigation_arrow" ? "navigate_arw" : ""}`} onClick={() => {setShow(true); setShowContent(item)}}>
                        {childern}
                        {tiles_layout_type === "text_under_image" && item?.button_cta?.label && item.button_cta?.theme !== "navigation_arrow" &&
                            <CTABtnModule button_cta={item.button_cta}/>
                        }
                    </a>
                :
                    <a href="javascript:;" className={`tiles_link ${item?.button_cta?.label ? "" : "no_cta"} ${item.button_cta?.theme === "navigation_arrow" ? "navigate_arw" : ""}`}>
                        {childern}
                        {tiles_layout_type === "text_under_image" && item?.button_cta?.label && item.button_cta?.theme !== "navigation_arrow" &&
                            <CTABtnModule button_cta={item.button_cta}/>
                        }
                    </a>
            }
        </React.Fragment>
    );
};
export default TilesBox;